import React from "react"

import { connectRefinementList } from "react-instantsearch-dom"
import { RefinementListProvided, RefinementListExposed } from "react-instantsearch-core"
import { FormControlLabel, Checkbox } from "@mui/material"

import FilterWrapper from "./FilterWrapper"

const CheckboxFilter = ({
	title,
	items,
	refine,
	hint,
	omitWrapper,
	canRefine,
}: Props & RefinementListProvided) => {
	if (!canRefine) return null

	return (
		<FilterWrapper title={title} omitWrapper={omitWrapper} hint={hint}>
			{items.map((item) => {
				const { label, value, count, isRefined } = item

				const Label = () => (
					<div>
						{label} <span style={{ color: "grey", fontSize: "0.8rem" }}>({count})</span>
					</div>
				)

				const refineValue = () => {
					refine(value)
				}

				return (
					<div key={label}>
						<FormControlLabel
							control={
								<Checkbox
									checked={isRefined}
									value={value}
									style={{ margin: "2px", padding: "2px", fontSize: "0.85rem" }}
									onChange={refineValue}
								/>
							}
							label={<Label />}
						/>
					</div>
				)
			})}
		</FilterWrapper>
	)
}

type Props = {
	title: string
	omitWrapper: boolean
	hint?: string
}

const ExposedCheckboxFilter: React.ComponentClass<RefinementListExposed & Props> =
	connectRefinementList(CheckboxFilter)

export default ExposedCheckboxFilter
